import resourceService from './resource_service';

const modelName = 'chemical-cost';

const attributes = {
  cost: '',
  deletedAt: '',
  expectedDailyUsage: '',
};

const relationships = {
  chemical: {
    jsonApi: 'hasOne',
    update: true,
  },
  site: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
